import { GridMenuGroupHeader } from './GridMenu/GridMenuGroupHeader.js';
import { GridMenuItem } from './GridMenu/GridMenuItem.js';
import { GridMenuList } from './GridMenu/GridMenuList.js';
import { GridMenuSeparator } from './GridMenu/GridMenuSeparator.js';
import { GridSubmenu } from './GridMenu/GridSubmenu.js';
import { TableMenuGroupHeader } from './TableMenu/TableMenuGroupHeader.js';
import { TableMenuItem } from './TableMenu/TableMenuItem.js';
import { TableMenuList } from './TableMenu/TableMenuList.js';
import { TableMenuSeparator } from './TableMenu/TableMenuSeparator.js';
import { TableSubmenu } from './TableMenu/TableSubmenu.js';
import { jsx } from 'react/jsx-runtime';

function MenuContents(props) {
  const {
    items,
    activeSubmenus,
    activeIndex,
    path,
    size,
    layout,
    onSelectItem,
    onSelectSubmenu
  } = props;
  const MenuList = layout === 'grid' ? GridMenuList : TableMenuList;
  const MenuItem = layout === 'grid' ? GridMenuItem : TableMenuItem;
  const MenuSeparator = layout === 'grid' ? GridMenuSeparator : TableMenuSeparator;
  const MenuGroupHeader = layout === 'grid' ? GridMenuGroupHeader : TableMenuGroupHeader;
  const Submenu = layout === 'grid' ? GridSubmenu : TableSubmenu;
  return /*#__PURE__*/jsx(MenuList, {
    children: items.map((item, i) => {
      const active = !activeSubmenus.length && i === activeIndex;
      switch (item.data.type) {
        case 'menu-item':
          return /*#__PURE__*/jsx(MenuItem, {
            active: active,
            size: size,
            onSelect: onSelectItem,
            ...item.data.props
          }, i);
        case 'menu-separator':
          return /*#__PURE__*/jsx(MenuSeparator, {}, i);
        case 'menu-group-header':
          return /*#__PURE__*/jsx(MenuGroupHeader, {
            size: size,
            ...item.data.props
          }, i);
        case 'submenu':
          return /*#__PURE__*/jsx(Submenu, {
            active: active,
            isOpen: i === activeSubmenus[0],
            noScroll: activeSubmenus.length > 1,
            size: size,
            value: [...path, i],
            onSelect: onSelectSubmenu,
            ...item.data.props,
            children: /*#__PURE__*/jsx(MenuContents, {
              activeIndex: activeIndex,
              activeSubmenus: activeSubmenus.slice(1),
              items: item.children,
              path: [...path, i],
              size: size,
              layout: layout,
              onSelectItem: onSelectItem,
              onSelectSubmenu: onSelectSubmenu
            })
          }, i);
      }
    })
  });
}

export { MenuContents };
